import moment from "moment-timezone"
import { SessionLessonData } from "./session"

export function toDate(dateStr: string) {
  return moment(dateStr)
    .tz(localStorage.getItem("cent_timezone_identifier") || "Europe/London")
}

export function getNow() {
  return moment().tz(localStorage.getItem("cent_timezone_identifier") || "Europe/London");
}

export function onFlexi(sessionLessonData: SessionLessonData) {
  const isFlexi = sessionLessonData?.session.tbl_session_time?.tbl_student_enrolment?.[0]?.tbl_session_attendance?.is_flexi === 1;

  if(!isFlexi) return false;

  const now = getNow();
  const sessionDate = toDate(sessionLessonData?.session.ses_date)
    .add((parseInt(String(sessionLessonData?.session.tut_flexi_days)) + 1 ||  0), 'days');
  console.info(`isFlexi: ${isFlexi}, sessionDate: ${sessionDate}, now: ${now}, sessionDate < now: ${sessionDate < now}`);


  return now < sessionDate;
}

export function sessionStarted(sessionLessonData: SessionLessonData) {
  const now = getNow();
  const sessionDate = toDate(sessionLessonData?.session.ses_date);
console.info(`Now >= Session Date: ${sessionDate < now}, now: ${now}, sessionDate: ${sessionDate}`);
  return  now >= sessionDate;
}

export function sessionIsCompleted(sessionLessonData: SessionLessonData) {

  return parseInt(String(sessionLessonData?.session.ses_is_completed))=== 1;

}